import { render, staticRenderFns } from "./InvPT_Total.vue?vue&type=template&id=2e2c1c48"
import script from "./InvPT_Total.vue?vue&type=script&lang=js"
export * from "./InvPT_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports